export interface FAQItem {
  question: string;
  answer: string;
}

export const faqItems: FAQItem[] = [
  {
    question: '超碰在线真的免费吗？需要注册吗？',
    answer: '超碰在线完全免费，无需注册即可观看所有视频内容。我们通过广告收入维持平台运营，为用户提供零门槛的观影体验。只需打开网站，即可立即开始观看。',
  },
  {
    question: '为什么有些视频加载比较慢？',
    answer: '视频加载速度受多种因素影响，包括您的网络带宽、设备性能和当前在线人数。我们建议在网络状况良好时观看高清内容，或适当降低画质以获得更流畅的播放体验。超碰在线采用最新的CDN加速技术，大多数情况下视频加载速度极快。',
  },
  {
    question: '支持哪些设备观看？',
    answer: '超碰在线全面支持PC端、平板和手机端观看。我们的网站采用响应式设计，会根据您的设备屏幕自动调整布局，无论在电脑、iPad还是手机上，都能获得最佳的观看体验。',
  },
  {
    question: '视频多久更新一次？',
    answer: '超碰在线每日更新大量内容，涵盖电影、电视剧、综艺、动漫等多个分类。我们的内容团队全天候工作，确保第一时间为用户带来最新、最热门的视频资源。您可以在"最新更新"板块查看每日新增内容。',
  },
  {
    question: '可以下载视频离线观看吗？',
    answer: '目前超碰在线仅支持在线播放，暂不提供视频下载功能。在线播放可以确保您观看到的是最新、最高清的版本，且不会占用您的设备存储空间。我们正在评估离线观看功能，敬请期待。',
  },
  {
    question: '如何搜索我想看的视频？',
    answer: '您可以使用首页顶部的搜索框输入视频名称、演员或导演进行搜索。也可以通过浏览首页的分类导航，按照电影、电视剧、综艺、动漫等分类查找感兴趣的内容。每个分类页面还提供了进一步的筛选功能。',
  },
  {
    question: '视频画质最高支持多少？',
    answer: '超碰在线最高支持1080P全高清画质播放。系统会根据您的网络状况自动选择最佳画质，您也可以在播放器中手动切换画质选项。对于部分最新内容，我们还提供了4K超高清选项。',
  },
  {
    question: '遇到播放问题怎么办？',
    answer: '如果您遇到视频无法播放、卡顿等问题，建议先尝试刷新页面或切换浏览器。如果问题持续存在，请通过"关于我们"页面的联系方式与我们取得联系，我们的技术团队会尽快为您解决。',
  },
];